import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";
import AppConstant from "../../../constants/app.constants";

//Import Breadcrumb
import Breadcrumbs from "components/Common/BreadcrumbTitle";

import { getApiConfiguration } from "http/UAM/apiConfig.helper";
import { decryptedValue, isPermission } from "common/utility";
import TableContainerV1 from '../../../components/Common/TableContainerV1';
import ToastDialog from "components/Common/ToastDialog";
import { useToast } from "ToastStore";

const TableActionsComponent = (rowData) => {
  const navigate = useNavigate();
  const user = decryptedValue(localStorage.getItem("user"));
  const navigateToeViewApiConfiguration = (id) => {
    const encryptedId = btoa(id.toString());
    navigate(`/${user.roleName}/api-config/view?id=${encodeURIComponent(encryptedId)}`)
  };


  const navigateToeEditApiConfiguration = (id) => {
    const encryptedId = btoa(id.toString());
    navigate(`/${user.roleName}/api-config/edit?id=${encodeURIComponent(encryptedId)}`)
  };

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem
          onClick={() => {
            navigateToeViewApiConfiguration(rowData.id);
          }
          }
        >
          <i className="mdi mdi-eye font-size-16 text-success me-1" id="edittooltip"></i>
          View
          <UncontrolledTooltip placement="top" target="edittooltip">
            View
          </UncontrolledTooltip>
        </DropdownItem>
        <DropdownItem
          onClick={() => {
            navigateToeEditApiConfiguration(rowData.id);
          }
          }
        >
          <i className="mdi mdi-pencil font-size-16 text-success me-1" id="edittooltip"></i>
          Edit
          <UncontrolledTooltip placement="top" target="edittooltip">
            Edit
          </UncontrolledTooltip>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

const ApiConfiguration = props => {
  document.title = "Api Configuration | FundLync";

  const navigate = useNavigate();

  const [apiConfigList, setApiConfigList] = useState([]);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0 });
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [isNewAPIPermission, setIsNewAPIPermission] = useState(false)

  const [sortingOptions, setSortingOptions] = useState({ column: 'id', isAsc: false, optionalColumn: ['Action'] })

  const { message, showToast, role, handleHideToast } = useToast()
  const user = decryptedValue(localStorage.getItem("user"));
  // Customber Column
  const columns = useMemo(
    () => [
      {
        Header: 'Id',
        accessor: 'id',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || '';
          ;
        }
      },
      {
        Header: 'URL',
        accessor: 'url',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || '';
        }
      },
      {
        Header: 'Purpose',
        accessor: 'purpose',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || '';
        }
      },
      {
        Header: 'Action',
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(rowData);
        }
      },
    ],
    []
  );


  useEffect(() => {
    getApiConfiguration({ page: 1, limit: AppConstant.TABLE_RECORD_SIZE })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setApiConfigList(responseFromAPI.data.data);
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems });
        }
      }).catch(error => { })

    checkPermissions()
  }, []);

  const checkPermissions = async () => {

    const isNewAPIpermission = await isPermission("api_configuration", "create_permission")
    setIsNewAPIPermission(isNewAPIpermission)
  }

  const handleCustomerClicks = () => {
    navigate(`/${user.roleName}/api-config/add`)
  };

  const handlePageChange = (page, pageSize, searchKey = searchValue, columnName = columnId, sortingOrder = sortingOrderStatus) => {
    setPageSize(pageSize);
    getApiConfiguration({ page, limit: pageSize, searchKey, columnName, sortingOrder })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setApiConfigList(responseFromAPI.data.data);
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems });
        } else {
          setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
          setApiConfigList([])
        }
      }).catch(error => { })
  }

  const handleSortColumn = (option) => {
    setSortingOptions(option)
    const columnName = option.column;
    setColumnId(columnName)
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder)
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder)
  }

  const handleSearchFilter = (value, pageSize) => {
    setSearchValue(value)
    handlePageChange(1, pageSize, value);
  }
  const handleClearSearch = () => {
    setSearchValue("")
    handlePageChange(1, pageSize, "", "id", "desc")
  }
  const buttonSection = (
    <div className="text-sm-end">
      {isNewAPIPermission &&
        <Button
          type="button"
          color="success"
          className="btn-rounded mb-2 me-2"
          onClick={handleCustomerClicks}
        >
          <i className="mdi mdi-plus me-1" />
          {'New Api Configuration'}
        </Button>
      }
    </div>);

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="API CONFIGURATIONS" />
        <Row className="vertical-scroll">
          <Col xs="12">
            <Card>
              <CardBody>
                <TableContainerV1
                  columns={columns}
                  data={apiConfigList}
                  pagination={pagination}
                  handlePageChange={handlePageChange}
                  handleSearchFilter={handleSearchFilter}
                  customSection={buttonSection}
                  sortOptions={sortingOptions}
                  handleSortColumn={handleSortColumn}
                  handleClearSearch={handleClearSearch}
                  className="custom-header-css"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <ToastDialog
        message={message}
        showToast={showToast}
        role={role}
        onCloseFn={handleHideToast}
      />
    </div>
  );
};

export default ApiConfiguration;